module.exports = __webpack_public_path__ + "static/media/IG-gray.2506c791.svg";